import React, { useState } from "react";
import { loomMatches } from "../../karkhana/home/loomCodes";
import { useStudioLooms } from "./studioLooms";

type Props = {
  selected: string[];
  onChange: (ids: string[]) => void;
  /** With `only`, the sheet title already names the section. */
  showTitle: boolean;
  hidden: boolean;
};

/** Looms past this many get a search box (B1 finds B01, an old number finds the renamed loom). */
const SEARCH_FROM = 12;

/** Studio product list filter: pieces woven on any chosen karkhana loom. Renders nothing for a studio with no looms. */
const LoomFilterSection = ({ selected, onChange, showTitle, hidden }: Props) => {
  const looms = useStudioLooms();
  const [typed, setTyped] = useState("");
  if (!looms || !looms.length) return null;
  const toggle = (id: string) => onChange(selected.includes(id) ? selected.filter((l) => l !== id) : [...selected, id]);
  const shown = looms.filter((l) => selected.includes(l.id) || loomMatches(l, typed));
  return (
    <section className="pl-fgrp" data-section="loom" hidden={hidden} aria-label="Loom">
      <div className="pl-fgrp__h">
        <span>{showTitle ? "Loom" : ""}</span>
        {selected.length ? <i>{selected.length}</i> : null}
      </div>
      {looms.length > SEARCH_FROM ? (
        <label className="pl-input">
          <input type="search" aria-label="Find a loom" placeholder="Loom number, e.g. B01" value={typed} onChange={(e) => setTyped(e.target.value)} />
        </label>
      ) : null}
      <div className="pl-chips is-wrap">
        {shown.map((loom) => {
          const on = selected.includes(loom.id);
          return (
            <button key={loom.id} type="button" aria-pressed={on} className={`pl-chip${on ? " is-on" : ""}`} onClick={() => toggle(loom.id)}>
              {loom.code}
              {loom.retired ? " (retired)" : ""}
            </button>
          );
        })}
        {!shown.length ? <small>No loom {typed}</small> : null}
      </div>
    </section>
  );
};

export default LoomFilterSection;
